import { Component, computed, input } from '@angular/core';
import { NotificationLayoutComponent } from '../../notification-detail-layout/notification-detail-layout.component';
import { NotificationStep, TeacherNotification } from '../../../core/models/notification.model';
import {
  SUBSCRIPTION_TYPE_DIAGNOSTIC,
  SUBSCRIPTION_TYPE_DIAGNOSTIC_MID, SUBSCRIPTION_TYPE_DIAGNOSTIC_POST,
  SUBSCRIPTION_TYPE_INTERVENTION, SUBSCRIPTION_TYPE_SCREENER
} from '../../../core/constants/subscription';

@Component({
  selector: 'wf-diagnostic-time-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="⏱ A student may need your support during the Diagnostic"
      [preambles]="[
        {
          text: 'The student(s) below have spent more than 25 minutes on just the first level of the Diagnostic. '
            + 'Typically, students complete all seven levels in about 50–60 minutes, so this is a signal worth looking into. '
            + 'A little encouragement from you can go a long way.'
        },
      ]"
      [steps]="steps"
      [ids]="ids()"
      ctaLabel=""
      ctaRoute=""
      closingText="Need ideas for supporting a student who’s disengaged? We’re here — give us a call or send an email."
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
          <th class="th">Date</th>
          <th class="th">Assessment</th>
          <th class="th">Time (min)</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
            <td class="td"><span class="date-display">{{ notification.data['displaydate'] }}</span></td>
            <td class="td">{{ getAssessment(notification.data.subscriptiontype, notification.data.assessmenttype) }}</td>
            <td class="td"><span class="badge-warn">{{ notification.data.sessiontime }}</span></td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true
})
export class DiagnosticTimeNotificationComponent {
  readonly data = input.required<TeacherNotification[] | null>();
  readonly ids = computed(() => {
    const notifications = this.data() ?? [];

    return { alerts: notifications.map(notification => notification.alertID) };
  });
  readonly steps: NotificationStep[] = [
    {
      title: 'Observe during their next session',
      body: 'Sit nearby and make sure they understand what to do. Sometimes just having you close by is enough to help them stay focused and on track.',
    },
    {
      title: 'Encourage them to keep going',
      body: 'Remind the student to do their best and work until they finish. Most students complete 2–3 levels per day '
        + 'when they’re engaged — letting them know you’re rooting for them helps. A valid Diagnostic score depends on the student giving their full effort.',
      variant: 'green',
    }
  ];

  getAssessment(subscription: string, assessment: string): string {
    const subscriptionValue = parseInt(subscription, 10);
    const assessmentValue = parseInt(assessment, 10);

    if (isNaN(subscriptionValue) || isNaN(assessmentValue)) return '';

    if (subscriptionValue === SUBSCRIPTION_TYPE_INTERVENTION) {
      if (assessmentValue === SUBSCRIPTION_TYPE_DIAGNOSTIC) {
        return 'System Pre';
      } else if (assessmentValue == SUBSCRIPTION_TYPE_DIAGNOSTIC_MID) {
        return 'System Mid';
      } else if (assessmentValue === SUBSCRIPTION_TYPE_DIAGNOSTIC_POST) {
        return ' System Post';
      }
    } else if (subscriptionValue === SUBSCRIPTION_TYPE_DIAGNOSTIC) {
      return 'Diagnostic';
    } else if (subscriptionValue === SUBSCRIPTION_TYPE_SCREENER) {
      return 'Screener';
    }

    return '';
  }
}
